import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router'
import { Link } from 'react-router-dom'
import { LiveMissionToken } from 'src/components/Gamification/LiveMissionToken'
import { getLiveSession } from 'src/ducks/liveSession'
import routes from 'src/routes'
import styled from 'styled-components'
import ChatSection from '../components/ChatSection'
import FacultySide from '../components/FacultySide'
import LoadIcon from '../components/LoadIcon'
import PageWithBg from '../components/PageWithBg'
import config from '../config'
import { getHallChatDb, getHallQuestionDb } from '../firebaseConfig'
import { COLORS, SIZES } from '../styles/theme'
import Amplitude from '../utils/amplitudeHelper'
import { useAutoMute } from '../utils/useAutoMute'

const Page = styled.div`
  overflow: hidden;
  .content {
    ${config.layout.auditoriumVid}
    position: absolute;
    background: black;

    iframe {
      height: 100%;
      width: 100%;
    }
  }
  .chat {
    max-width: 400px;
    position: fixed;
    padding-top: ${SIZES.navHeight};
    top: 0;
    left: 70%;
    bottom: 0;
    right: 5%;
    z-index: 30;
    margin: auto;
  }
  .attendance {
    /* border: 1px solid red; */
    position: fixed;
    bottom: 20%;
    left: 12%;
    right: 34%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
  .action-button {
    display: inline-block;
    background: linear-gradient(#F1CA13, #FF9F00);
    border-radius: 8px;
    border: 1px solid white;
    text-decoration: none;
    color: #4D4D4D;
    padding: 6px 24px;
    font-weight: 700;
    font-size: 90%;
    cursor: pointer;
    height: 100%;
    /* min-width: 150px; */
  }

  #tooltip-container {
    background-color: #000;
    padding: 18px;
    position: fixed;
    top: 20%;
    bottom: 28%;
    left: 1%;
    right: 86%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .tooltip-text {
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    margin-top: 12px;
  }
  .toggle-live-btn {
    cursor: pointer;
    animation: bounce 1500ms infinite;
  }
`

export default function AuditoriumPage({ currentUser }) {
  useAutoMute()
  const history = useHistory()
  const [loading, setLoading] = useState(true)
  const [facultySide, setFacultySide] = useState(false)
  // const [missions, setMissions] = useState([])
  const dispatch = useDispatch()
  const { sessionId } = useParams()
  const { session } = useSelector((state) => state.liveSession)
  
  useEffect(() => {
    document.title = `${config.eventName} | Conference`
  }, [])

  const toggleSidebar = () => {
    history.push(routes.programme)
  }
  const toggleFacultySide = () => {
    if (facultySide === false) {
      Amplitude.clickFaculty()
    }
    setFacultySide(!facultySide)
  }

  // useEffect(() => {
  //   setMissions(currentUser.missions?.filter(ms=>ms.task_name===`auditorium_${hallNumber === 1 ? "a" : "b"}`))
  // }, [currentUser.missions, hallNumber])

  useEffect(() => {
    dispatch(getLiveSession(sessionId))
    Amplitude.watchLive(sessionId)
  }, [sessionId, dispatch])

  if (isEmpty(session)) {
    return <LoadIcon />
  }
  const playbackComponent = (
    <>
      {session?.playbackUrl ? (
        <div className="content">
          {loading && <LoadIcon />}
          <iframe
            title="Live Broadcast"
            src={`${session.playbackUrl}&autoplay=1`}
            allow="autoplay; fullscreen"
            allowFullScreen
            frameBorder="0"
            onLoad={() => {
              setLoading(false)
            }}
          />
        </div>
      ) : (
        <div className="content">
          <div className="noStreamUrl">No playbackUrl URL for this session</div>
        </div>
      )}
    </>
  )

  return (
    <>
      {loading && <LoadIcon />}
      <Page>
        <FacultySide open={facultySide} toggleSidebar={toggleFacultySide} />
        <PageWithBg bgImg={config.assets.auditorium1.landscape}>

          {playbackComponent}

          <div className="chat h-100">
            <ChatSection 
              currentUser={currentUser} 
              firebaseDb={getHallQuestionDb(sessionId)} 
              chatDb={getHallChatDb(sessionId)} 
            />
          </div>
          <div className="attendance">
            {/* <div>
              <Link className="action-button" to={hallNumber === 1 ? routes.auditorium2 : routes.auditorium1} >
                TO LECTURE HALL {hallNumber === 1 ? "B" : "A"}
              </Link>
            </div> */}
            <div>
              <button type="button" className="action-button" onClick={toggleFacultySide}>
                FACULTY
              </button>
            </div>
            <div>
              <button type="button" className="action-button" onClick={toggleSidebar}>
                PROGRAMME
              </button>
            </div>
          </div>
        </PageWithBg>
        {/* {missions.map(mission => (
          <LiveMissionToken mission={mission} />
        ))} */}
        {/* <AdvertisementModal hallNumber={hallNumber} day={day} showModal={showAdv} hideModal={() => setShowAdv(false)} /> */}
      </Page>
    </>
  )
}
